<template>
  <v-app
    v-cloak
    :style="{'background-color':$vuetify.theme.themes[_CMS_theme].background}"
  >
    <WsAppLayout v-if="_template === 'app' && $store.state.user.tokenChecked" />
    <WsAuthLayout v-else-if="_template === 'auth'" />
    <WsAlertDialog
      ref="errorDialog"
      :title="$store.state.error.errorMessage"
    >
      <template v-slot:bottom-btn>
        <WsBtn
          color="deleteBtn white--text"
          @click="$_onClickErrorDialog()"
        >{{ '確定' }}</WsBtn>
      </template>
    </WsAlertDialog>
  </v-app>
</template>

<script>
import '@mdi/font/css/materialdesignicons.css'

export default {
  name: "App",
  computed: {
    _template() {
      if (this.$route.meta && this.$route.meta.template) {
        return this.$route.meta.template;
      } else {
        return "app";
      }
    },
    _isApiError() {
      return this.$store.state.error.isError;
    }
  },
  watch: {
    _isApiError() {
      if (!this.$refs.errorDialog) return;
      if (this._isApiError) this.$refs.errorDialog.open();
      else this.$refs.errorDialog.close();
    }
  },
  methods: {
    $_onClickErrorDialog() {
      this.$store.dispatch("error/setNoData", false);
      if (!this.$store.state.user.currentUser) return;
      if (this.$router.history.length > 1) this.$router.go(-1);
      else this.$router.push('/');
    }
  }
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/app.scss";
@import "@/__scssstone/app";
</style>